export const CERTIFICATES = 'CERTIFICATES';
export type CERTIFICATES = typeof CERTIFICATES;

export const CERTIFICATES_SUCCESS = 'CERTIFICATES_SUCCESS';
export type CERTIFICATES_SUCCESS = typeof CERTIFICATES_SUCCESS;

export const CERTIFICATES_FAILED = 'CERTIFICATES_FAILED';
export type CERTIFICATES_FAILED = typeof CERTIFICATES_FAILED;

export const DELETE_CERTIFICATE = 'DELETE_CERTIFICATE';
export type DELETE_CERTIFICATE = typeof DELETE_CERTIFICATE;

export const DELETE_CERTIFICATE_SUCCESS = 'DELETE_CERTIFICATE_SUCCESS';
export type DELETE_CERTIFICATE_SUCCESS = typeof DELETE_CERTIFICATE_SUCCESS;

export const DELETE_CERTIFICATE_FAILED = 'DELETE_CERTIFICATE_FAILED';
export type DELETE_CERTIFICATE_FAILED = typeof DELETE_CERTIFICATE_FAILED;

export const REPLACE_CERTIFICATE = 'REPLACE_CERTIFICATE';
export type REPLACE_CERTIFICATE = typeof REPLACE_CERTIFICATE;

export const REPLACE_CERTIFICATE_SUCCESS = 'REPLACE_CERTIFICATE_SUCCESS';
export type REPLACE_CERTIFICATE_SUCCESS = typeof REPLACE_CERTIFICATE_SUCCESS;

export const REPLACE_CERTIFICATE_FAILED = 'REPLACE_CERTIFICATE_FAILED';
export type REPLACE_CERTIFICATE_FAILED = typeof REPLACE_CERTIFICATE_FAILED;

export const CERTIFICATE_DETAIL = 'CERTIFICATE_DETAIL';
export type CERTIFICATE_DETAIL = typeof CERTIFICATE_DETAIL;

export const CERTIFICATE_DETAIL_SUCCESS = 'CERTIFICATE_DETAIL_SUCCESS';
export type CERTIFICATE_DETAIL_SUCCESS = typeof CERTIFICATE_DETAIL_SUCCESS;

export const CERTIFICATE_DETAIL_FAILED = 'CERTIFICATE_DETAIL_FAILED';
export type CERTIFICATE_DETAIL_FAILED = typeof CERTIFICATE_DETAIL_FAILED;

export const CERTIFICATE_REFERENCES = 'CERTIFICATE_REFERENCES';
export type CERTIFICATE_REFERENCES = typeof CERTIFICATE_REFERENCES;

export const CERTIFICATE_REFERENCES_SUCCESS = 'CERTIFICATE_REFERENCES_SUCCESS';
export type CERTIFICATE_REFERENCES_SUCCESS = typeof CERTIFICATE_REFERENCES_SUCCESS;

export const CERTIFICATE_REFERENCES_FAILED = 'CERTIFICATE_REFERENCES_FAILED';
export type CERTIFICATE_REFERENCES_FAILED = typeof CERTIFICATE_REFERENCES_FAILED;
